export default "__VITE_ASSET__BdSKxE$z__"